let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7vVGq")).then(() => parcelRequire('kpMZW'));